module.exports = __webpack_public_path__ + "static/so3-5056bd896e8178bd6e1df3f1597038dd.gif";